// extracted by mini-css-extract-plugin
export default {"video_container":"CarouselClient_video_container__2evb5","overlay":"CarouselClient_overlay__V+ey1","link":"CarouselClient_link__PkaaA"};